import { render, staticRenderFns } from "./StartInvesting.vue?vue&type=template&id=5704ad4a&scoped=true&"
import script from "./StartInvesting.vue?vue&type=script&lang=js&"
export * from "./StartInvesting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5704ad4a",
  null
  
)

export default component.exports